<template>
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12">
                        Exportar Respuestas 
                    </v-col>
                    
            
                </v-row>
                 <v-row class="col-md-12 pt-0 pb-0 mb-0">
                    <v-col cols="12" md="5" sm="5" xs="12" class="pt-0 pb-0 mb-0">
                        <v-select
                            v-model="datosItem.periodoMedicionId"
                            :items="periodos"
                            :loading="ddPeriodosLoading"
                            dense
                            outlined
                            label="Periodo de medición"
                            item-text="anioMedicion"
                            item-value="id"
                            :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                            @change="establecido=false;"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="7" sm="7" xs="12" class="pt-0 pb-0 mb-0">
                        <v-select
                            v-model="indiceSeleccionadoId"
                            :items="indices"
                            :loading="ddIndicesLoading"
                            :disabled="datosItem.periodoMedicionId<=0"
                            dense
                            outlined
                            label="Seleccionar Índice"
                            item-text="nombreIndice"
                            item-value="id"
                            :hint="datosItem.periodoMedicionId<=0 ? 'Debe seleccionar un periodo de medición' : ''"
                            :no-data-text="indices ? 'Selecciona un índice' : 'No se han registrado índices'"
                            @change="obtenerBoletasPorIndice(); establecido=false;"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row class="col-md-12 pt-0 mt-0">
                    <v-col cols="12" md="5" sm="5" xs="12" class="pt-0 mt-0 pb-1">
                        <v-select
                            v-model="datosItem.boletasId"
                            :items="boletas"
                            :loading="ddBoletasLoading"
                            dense
                            outlined
                            label="Seleccionar boleta"
                            item-text="descripcion"
                            item-value="id"
                            :no-data-text="indices.length<=0 ? 'No se ha seleccionado un índice' : 'El índice seleccionado no tiene boletas asignadas'"
                            @change="establecido=false;"
                        ></v-select>
                    </v-col>

                     <v-col cols="12" md="7" sm="7" xs="12" class="pt-0 mt-0 pb-1">
                        <v-btn
                            color="primary"
                            class="mb-2 float-right bg-light-blue"
                            @click="obtenerrespuestasAprobadas();"
                            :disabled="datosItem.boletasId<=0 || indiceSeleccionadoId<=0"
                        >
                            Buscar
                            <v-icon right>mdi-magnify</v-icon>
                        </v-btn>
                    </v-col> 

                    
                </v-row>

                <v-row v-if="establecido==false">
                    <v-col cols="12">
                        <v-alert
                            text
                            prominent
                            type="error"
                            icon="mdi-alert"
                            dense
                            small
                            >
                                <p class="mt-3">Para poder exportar respuestas, debes de establecer la configuración de periodo de medición, índice y boleta.</p> 
                            </v-alert>
                    </v-col>
                </v-row>

                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>

            
                        
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="4" md="4" xs="12">
                        <!--<download-excel 
                            class="btn btn-md btn-primary bg-light-blue" 
                            :fetch="exportarTabla" 
                            :disabled="true"
                            worksheet="DICCIONARIO_RESPUESTAS"
                        >
                            EXPORTAR
                            <v-icon left>mdi-database-export</v-icon>
                            </download-excel>-->

                        <v-btn
                            color="primary"
                            class="mb-2 float-right bg-light-blue"
                            @click="exportTest();"
                            
                        >
                            Exportart a Excel
                            <v-icon right>mdi-database-export</v-icon>
                        </v-btn>
                    
                    </v-col> 

                    <v-col cols="12" md="8" sm="8" xs="12">
                        <v-text-field
                            outlined
                            autocomplete="off"
                            dense
                            v-model="tableFilter"
                            label="Buscar"
                            maxlength="100"
                        ></v-text-field>
                    </v-col>

                   
                </v-row>


                <SubHeader subHeaderTitle="RESPUESTAS DE MUNICIPALIDADES " />
                
                <template>
                <v-data-table
                        :headers="headers"
                        :items="respuestasAprobadas"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="tableFilter"
                        :items-per-page="10"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                        dense
                    >
                     <!--<template v-slot:header="{ header }">
                        <th >
                            Municipio {{header}}
                        </th>
                        <th colspan="100%">
                            Respuestas
                        </th>
                    </template>-->
                    <template v-slot:item="{ item }">
                        <tr>
                            <!--<td>{{ item.id }}</td>-->
                            <td>{{ item.codigoMunicipio }}</td>
                            <td>{{ item.nombreMunicipio }}</td>
                            <td v-for="respuesta in item.respuestas" v-bind:key="respuesta.idRespuesta">

                                    <p class="blue--text darken-1--text">{{respuesta.nombreRespuesta}}:<small class="font-weight-black blue-grey--text darken-4--text text-subtitle-2"> {{respuesta.respuesta}}</small></p>
                            </td>
                          
                         
                        </tr>
                    </template>

                </v-data-table>
                </template>
            </v-card-text>
        </v-card>

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import Vue from 'vue';
import moment from "moment";
import XLSX from 'xlsx';

import validations from "@/core/untils/validations.js";
import SubHeader from "@/view/components/subheader/SubHeader";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_INDICES } from "@/core/services/store/catalogos/indice.module";
import { OBTENER_PERIODOS } from "@/core/services/store/catalogos/periodomedicion.module";
import { OBTENER_BOLETAS } from "@/core/services/store/boletas/boleta.module";
import { OBTENER_RESPUESTAS_MUNI_APROBADAS} from "@/core/services/store/preguntasperiodoboleta/preguntaperiodoboleta.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";

moment.locale('es');
Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
    }
});

export default {
    name: "ConfiguracionBoletas",
    components: {
        SnackAlert,
        SubHeader,
        DialogLoader
    },
    data() {
        return {
            tableLoading: false,
            ddPreguntasLoading:false,
            ddBoletasLoading:false,
            ddSubPreguntasLoading:false,
            respuestasAprobadas:[],
            tableFilter:'',
            validForm:false,
            validForm2: false,
            establecido:false,
            itemName: "Índices",
            dialog: false,
            dialogAsingarSub:false,
            modalTitle: 'Registrar Índice',
            btnRegistroLoading: false,
            btnRegistroSubLoading:false,
            dialogLoaderVisible: false,
            activePicker:null,
            menuFechaApertura: false,
            menuFechaCierre:false,
            fechas: {
                fechaApertura:'',
                fechaCierre: '',
            },
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Guardar',
            accion: 1,
            indices: [],
            indiceSeleccionadoId:0,
            preguntas: [],
            subpreguntas:[],
            subPreguntasAsignadas:[],
            datosExportacion: [],
            subPreguntaSeleccionadaId:0,
            preguntasAsignar:[],
            boletas: [],
            ddIndicesLoading: false,
            ddPeriodosLoading: false,
            periodos: [],
            switchItemEstado: true,
            visitaCampoValores: [{id: 'SI', visita: 'Si'}, {id: 'NO', visita: 'No'}],
            datosItem: {
                id: 0,
                preguntasId:0,
                visitaCampo: 'No',
                noOrdenPregunta: "0",
                periodoMedicionId: 0,
                boletasId:0,
                estadosId: 1
            },
            ...validations
        } 
    }, 
    methods: {
        //!Definir la fecha máxima que se puede seleccionar en el datepicker
        maxDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear() + 1);
            return date.toISOString().substr(0, 10);
        },

        //!Definir la fecha minima que se puede seleccionar en el datepicker
        minDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear());
            return date.toISOString().substr(0, 10);
        },


        modalNueva(){
            this.accion =1;
            this.modalTitle='Asignar pregunta a boleta';
            this.btnRegistroText='Guardar';
            this.switchItemEstado=true;
            this.dialog=true;
        },

        resetForm(){
           // this.$refs.form.reset();
            let boletaSeleccionada = this.datosItem.boletasId;
             this.datosItem= {
                id: 0,
                preguntasId: 0,
                boletasId: boletaSeleccionada,
                noOrdenPregunta: "0",
                periodoMedicionId: this.datosItem.periodoMedicionId,
                indicesId: 0,
                estadosId: 1
            };
            this.accion=1;
            this.switchItemEstado = true;
            //console.log(this.switchItemEstado)
        },

        resetFormSub(){
            this.accion=1;

        },

        async obtenerIndices(){
            this.indices=[];
            this.ddIndicesLoading=true;
            await this.$store
            .dispatch(OBTENER_INDICES, 1)
            .then(res => {
                if(res.status===200){
                    this.indices=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddIndicesLoading=false;
               
            }
            )
            .catch(() => {
                this.ddIndicesLoading=false;
                //console.warn(err)
            });
        },


        //!Obtener boletas por indice seleccionado y periodo
        async obtenerBoletasPorIndice(){

            this.datosItem.boletasId=0;
            this.boletas=[];
            this.ddBoletasLoading=true;
            await this.$store
            .dispatch(OBTENER_BOLETAS, {idPeriodo: this.datosItem.periodoMedicionId, idIndice: this.indiceSeleccionadoId})
            .then(res => {
                if(res.status===200){
                    this.boletas=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddBoletasLoading=false;
               
            }
            )
            .catch(() => {
                this.ddBoletasLoading=false;
                //console.warn(err)
            });
        },


        //!Obtener los periodos para la tabla
        obtnenerPeriodosMedicion(){
            this.ddPeriodosLoading = true;
            this.periodos=[];
            
            this.$store
                .dispatch(OBTENER_PERIODOS)
                .then(() => {
                    this.periodos = this.$store.state.periodomedicion.periodos;
                    this.ddPeriodosLoading =false;
                })
                .catch(() => {
                    this.ddPeriodosLoading = false;
                });

        },

    //!Obtener el diccionario de respuestas por periodo y boleta
    async obtenerrespuestasAprobadas(){
        //var jsonToPivotjson = require("json-to-pivot-json");
         this.establecido=true;
          this.tableLoading=true;
          this.respuestasAprobadas=[];
            await this.$store
            .dispatch(OBTENER_RESPUESTAS_MUNI_APROBADAS, {boletaId:this.datosItem.boletasId, periodoId: this.datosItem.periodoMedicionId})
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.respuestasAprobadas = res.data;
                    this.datosExportacion = [];
                 /*   var options = {
                        row: "nombreMunicipio", 
                         
                        column: "nombreRespuesta", 
                        value: "respuestaCorregida"
                    };

                    var output = jsonToPivotjson(this.respuestasAprobadas, options); 
                    this.datosExportacion = output;


                   */
                 
                    //let testArr=[];
                     //console.log(res.data)
                     //!Armar nuevo objeto para con personalizados para exportar a excel
                    res.data.forEach(element => {
                        let arr = [];
                        
                        arr["Codigo Departamento"] = element.codigoDepartamento;
                        arr["Nombre Departamento"] = element.nombreDepartamento;
                        arr["Codigo Municipio"] = element.codigoMunicipio;
                        arr["Nombre Municipio"] = element.nombreMunicipio;

                        
                        
                        Object.keys(element.respuestas).forEach(function(k){
                            var name = element.respuestas[k].nombreRespuesta;
                          //  console.log(name)
                            arr[name]= element.respuestas[k].respuesta;
                            //console.log(element.nombreMunicipio + " " + name + " " + element.respuestas[k].respuesta);
                        });
                       
                        //console.log(arr)
                        this.datosExportacion.push(arr);

                    });
                    
                    //console.log( this.datosExportacion)
                   
                   

                   // console.log(this.datosExportacion);
                } else {
                    //console.warn(res.message)
                    this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                }
                this.tableLoading=false;
            })
            .catch(() => {
                this.tableLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                });
        
    },


    exportarTabla(){
        
        
        if(this.datosExportacion.length<=0){
             this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', "No se han encontrado respuestas para exportar!");
            
        } else {
        this.dialogLoaderText= "Exportando respuestas...";
        this.dialogLoaderVisible=true;
        /*let datosExportacion = this.respuestasAprobadas.map(item => {
            return {
                "Id Respuesta": item.idRespuesta,
                "Nombre Respuesta": item.nombreRespuesta,
                "Tipo de Dato": item.tipoDato,
                "Id Pregunta": item.preguntaId,
                "Nombre Pregunta": item.nombrePregunta,
                "Id Pregunta Superior": item.idPreguntaSuperior,
                "Nombre Pregunta Superior": item.nombrePreguntaSuperior
            };
        });*/

        //console.log(datosExportacion);
        this.dialogLoaderVisible=false;
        return this.datosExportacion;
        }
    },


    exportTest(){
        // export json to Worksheet of Excel
      // only array possible
      var animalWS = XLSX.utils.json_to_sheet(this.datosExportacion) 
      //var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons) 

      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, animalWS, 'RESPUESTAS') // sheetAName is name of Worksheet
      //XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')   

      // export Excel file
      XLSX.writeFile(wb, 'indice.xlsx') // name of the file is 'book.xlsx'
    },


  


      

     
  
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Respuestas" },
            { title: "Exportación" }
        ]);
    },

    created(){
        this.obtenerIndices();
       // this.obtnenerItems();
        this.obtnenerPeriodosMedicion();
    },

    
    computed: {
        headers() {
            return [
                {
                    text: "Codigo municipio",
                    align: "start",
                    sortable: false,
                    value: "codigoMunicipio"
                },
                 {
                    text: "Nombre del municipio",
                    align: "start",
                    sortable: false,
                    value: "nombreMunicipio"
                },
                {
                    text: "Respuestas",
                    align: "start",
                    sortable: false,
                    class:"w-100",
                    value: "respuestas"
                }
            ]
        },

        //Cambiar el formato de fechas a DD-MM-YYY para mostrar y a YYYY-MM-DD para registrar en datosItem.fechaApertura
        fechaApertura:{
            get: function(){
                return this.fechas.fechaApertura
                ? moment(this.fechas.fechaApertura).format("DD-MM-YYYY")
                : null;
            },
            set: function(val){
                
                this.datosItem.fechaApertura = moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
                return val;
            }
        },   
        
        //Cambiar el formato de fechas a DD-MM-YYY para mostrar y a YYYY-MM-DD para registrar en datosItem.fechaCierre
        fechaCierre:{
            get: function(){
                return this.fechas.fechaCierre
                ? moment(this.fechas.fechaCierre).format("DD-MM-YYYY")
                : null;
            },
            set: function(val){
                
                this.datosItem.fechaCierre = moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
                return val;
            }
        },   
    },

    watch: {
        
        //Cambiar el formato de fecha de apertura/cierre del objeto datosItem al momento de que fechas.fechaApertura/fechas.fechaCierre cambie
        'fechas.fechaApertura': function(val){
            this.datosItem.fechaApertura = val;
        },

        'fechas.fechaCierre': function(val){
            this.datosItem.fechaCierre = val;
        },

    
    }

    
}
</script>
<style lang="">
    
</style>